import React from 'react';
import classNames from 'classnames';
import { useSpring, useChain, animated } from 'react-spring';
import MobileNavbarContext from '../mobile-navbar-context';
import Menus from './menus';

export default function Drawer() {
  const { state: { expanded } } = React.useContext(MobileNavbarContext);
  const fadeRef = React.useRef();
  const fade = useSpring({
    opacity: expanded ? 1 : 0,
    config: { mass: 1, tension: 500, friction: 30 },
    ref: fadeRef,
  });
  const trailRef = React.useRef();

  useChain([fadeRef, trailRef]);

  return (
    <animated.div className={classNames('mobile-navbar-content', { expanded })} style={fade}>
      <Menus trailRef={trailRef} />
    </animated.div>
  );
}
